import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { ContactsService } from '@boxx/contacts-core/lib/services/contacts.service';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EventsRepository } from './repositories/events.repository';
import { EVENTS_REPOSITORY } from './repositories/IEvents.repository';
import { EventsService } from './services/events.service';
import { EVENTS_SERVICE } from './services/IEvents.service';
import { EventsEffects } from './state/events.effects';
import { eventsReducer } from './state/events.reducer';
import { EVENTS_STORE_KEY } from './state/events.selectors';
import { EventsStore } from './state/events.store';

interface ModuleOptionsInterface {
  providers: Provider[];
}

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    StoreModule.forFeature(EVENTS_STORE_KEY, eventsReducer),
    EffectsModule.forFeature([EventsEffects]),
  ],
  exports: [],
})
export class EventsCoreModule {
  static forRoot(
    config?: ModuleOptionsInterface
  ): ModuleWithProviders<EventsCoreModule> {
    return {
      ngModule: EventsCoreModule,
      providers: [
        ContactsService,
        { provide: EVENTS_SERVICE, useClass: EventsService },
        { provide: EVENTS_REPOSITORY, useClass: EventsRepository },
        { provide: EVENTS_SERVICE, useClass: EventsService },
        ...(config?.providers || []),
        EventsStore,
      ],
    };
  }
}
